<!--
  Faktor + Berechnungsart als EINE Zelle. Der Faktor ist hervorgehoben (er ist die Antwort auf
  „was bekomme ich"), die Berechnungsart steht kleiner darunter — ohne sie ist die Zahl nicht
  lesbar. Faktor 0 wird sichtbar als „0" gerendert, nur gedämpft, nie leer.
-->
<span class="cp-factor inline-flex flex-column"
      [pTooltip]="tooltip"
      tooltipPosition="top">

    <span class="cp-factor__value font-semibold"
          [class.text-color-secondary]="zeroFactor || missing">
        {{ formattedValue }}
    </span>

    @if (modeLabel) {
        <span class="cp-factor__mode text-xs text-color-secondary white-space-nowrap">
            {{ modeLabel }}
        </span>
    }

</span>
